import { dateOf, esc, num, table, tile } from './sbchart.ts';

type Data = Record<string, any>;
export interface RosterLinks { student(person: Data): string }
const known = (n: unknown, digits = 0) => typeof n === 'number' && Number.isFinite(n) && n >= 0 ? num(n, digits) : '未记录';
const uint = (n: unknown): n is number => typeof n === 'number' && Number.isSafeInteger(n) && n >= 0 && n <= 0xffffffff;
const date = (n: unknown) => uint(n) ? dateOf(n) : '未记录';

/** 学校中的真实学籍，不从全城截断的候补榜单拼名单。 */
export function schoolRosterHTML(s: Data | null | undefined, links: RosterLinks, back: boolean): string {
  if (!s || s.missing) return '<div class="sb-empty">当前引擎未提供本校学生名单；不能从总人数推造学生。</div>';
  // 名册那天排过课才算「今天到课」;没排过、旧规则的照列名单,到课写上次排课的
  const currentAttendance = s.enabled === true && uint(s.day) && s.sampleDay === s.day;
  const notice = s.enabled === false ? '此城市使用旧教育规则' : s.sampleDay == null ? '还没排过课' : '';
  const id = s.school?.id;
  const validId = uint(id);
  const next = validId && uint(s.start) && uint(s.nextStart) && s.nextStart > s.start;
  const buttons = validId ? `<div class="sb-history-controls"><button data-students="${id}:prev"${back ? '' : ' disabled'}>上一页</button><button data-students="${id}:next:${next ? s.nextStart : ''}"${next ? '' : ' disabled'}>下一页</button><button data-students="${id}:first">回到首批学生</button></div>` : '';
  const hasStudents = Array.isArray(s.students);
  const students: Data[] = hasStudents ? s.students.slice(0, 100) : [];
  const rows = students.map(a => [links.student(a.who) + `<div class="meta">${esc(a.stage ?? '未记录')}</div>`,
    (uint(a.classNo) ? `第 ${a.classNo + 1} 班` : '未排班') +
      `<div>${a.present === true ? `${currentAttendance ? '' : '上次排课 · '}${known(a.hours, 1)} 小时` :
        a.present === false ? currentAttendance ? '未到课' : '上次排课没到' : '到课未记录'}</div>`,
    `<div style="white-space:normal">${known(a.learning, 1)} / ${known(a.required, 1)} 天<br>` +
      `${esc(typeof a.waiting === 'string' && a.waiting ? a.waiting : currentAttendance && a.present === true ? '已实际到课' : '—')}<br>` +
      `<span class="meta">本次入校登记 ${date(a.since)}</span></div>`]);
  const empty = !hasStudents ? '没有名单资料' : notice ? '本页没有学生' : '本页没有学籍归属本校的在城学生；可回首批查看。';
  return (notice ? `<p class="sb-empty">${notice}</p>` : '') +
    `<div class="sb-grid">${tile('本校录取', `${known(s.total)} 人`)}${tile(currentAttendance ? '本次实际到课' : '上次排课到课', `${known(s.present)} 人`)}${tile(currentAttendance ? '录取但未到课' : '上次排课没到', `${known(s.absent)} 人`)}</div>` +
    `<p class="meta">${date(s.day)} · 上次排课 ${date(s.sampleDay)} · 本页 ${students.length} 人，每页最多 100 人；点学生姓名看学籍、家庭与人生。</p>` + buttons +
    (rows.length ? table(['学生与课程', '班级与到课', '学习与当前安排'], rows) : `<div class="sb-empty">${empty}</div>`) +
    `<p class="meta">${esc(s.scope || '仅列当前学籍归属本校的居民；录取不等于到课，不含未分校的申请人和历届校友。')} 游戏运行时名单会变化；暂停后翻页可查看同一天的全校名单。</p>`;
}
